/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nutrient_SaltInputs */

const en_nutrient_salt = /** @type {(inputs: Nutrient_SaltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salt`)
};

const de_nutrient_salt = /** @type {(inputs: Nutrient_SaltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salz`)
};

/**
* | output |
* | --- |
* | "Salt" |
*
* @param {Nutrient_SaltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nutrient_salt = /** @type {((inputs?: Nutrient_SaltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nutrient_SaltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nutrient_salt(inputs)
	return en_nutrient_salt(inputs)
});